/* eslint-disable semi,semi-style */
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Tween from "rc-tween-one";
import platforms from "../../config";
import style from "./index.module.scss";
import { Modal } from "antd";

const Developer = () => {
  useEffect(() => {
    Omega.trackEvent("am_b_open_developer_sw", "能源开放平台-充电开发中心页", {
      host: location.hostname,
    });
  }, []);
  const showGuide = (it) => {
    if (it.path === "/join") {
      Modal.confirm({
        width: 550,
        title: "升级通知",
        content: (
          <>
            <p>
              充电供给（互联互通）接入已升级，请前往新平台使用。
              <a href="https://open-energy.xiaojukeji.com/manage" target="__blank">点击前往</a>
            </p>
            <p>
              如有使用疑问，可查看帮助文档。
              <a href="https://open-energy.xiaojukeji.com/document/30/196" target="__blank">点击查看</a>
            </p>
          </>
        ),
        centered:true,
        okText:'我知道了',
        cancelButtonProps:{style:{display:'none'}}
      });
    }
  };
  const cardRender = (it, i) => (
    <>
      <img
        src={`https://view.didistatic.com/static/dcms/548313280_medium_${
          it.imgIndex ? it.imgIndex : i + 1
        }.png`}
      />
      <h2>{it.title}</h2>
      <p>{it.desc}</p>
    </>
  );
  return (
    <React.Fragment>
      <h3 className={style.intro}>请选择您需要接入的平台</h3>
      <Tween
        animation={[
          { translateY: "15px", duration: 200, ease: "easeInOutSine" },
          { y: 0, opacity: 1 },
        ]}
        style={{ opacity: 0 }}
        className={style.platformWrapper}
      >
        <ul className={style.platform}>
          {platforms
            .filter((it) => !it.hidden)
            .map((it, i) => (
              <li key={i}>
                {it.isAbandon ? (
                  <a onClick={() => showGuide(it)}>{cardRender(it, i)}</a>
                ) : (
                  <Link to={it.path}>{cardRender(it, i)}</Link>
                )}
              </li>
            ))}
        </ul>
      </Tween>
    </React.Fragment>
  );
};

export default Developer;
